import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// 変数を定義
let initialWidth;
let finalWidth;

// 画面幅によって変数の値を変更
if (window.innerWidth <= 768) {
  // スマートフォンの場合
  initialWidth = "190px";
  finalWidth = "100%";
} else {
  // タブレット・PCの場合
  initialWidth = "352px";
  finalWidth = "100%";
}

gsap.fromTo(
  ".js-wide",
  { width: initialWidth, height: "438px", borderRadius: "600px 600px 0 0" },

  {
    width: "100%",
    height: "100vh",
    borderRadius: "0px 0px 0px 0px",

    scrollTrigger: {
      trigger: ".p-about-us-history",
      start: "top center",
      end: "600px center",
      scrub: 0.6,
      // markers: true,
    },
  }
);
